import Accordion from '@components/Accordion';
import Button from '@components/Button';
import Container from '@components/Container';
import Section from '@components/Section';
import Text from '@features/PageBuilder/components/Sections/components/Text';
import { isProduction } from '@utilities/environment';
import { insertURLParam } from '@utilities/helpers/common';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useState } from 'react';
import {
  Root,
  ErrorMessageAccordion,
  ButtonWrapper,
} from './ErrorFallback.module.css';

let didClickReset = false;

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const { t } = useTranslation(['account', 'common', 'checkout']);
  const router = useRouter();
  const [errorMessageOpen, setErrorMessageOpen] = useState(false);

  return (
    <Container>
      <Section className={Root}>
        <Text
          subheader={t('errorSubheader', { ns: 'common' })}
          header={t('errorHeader', { ns: 'common' })}
          textPosition="center"
          features={['half_width']}
          content={t('errorContent', { ns: 'common' })}
        />
        <div className={ButtonWrapper}>
          {!router.query.didReload && (
            <Button
              appearance="secondary"
              hasArrow={false}
              isLoading={didClickReset}
              onClick={() => {
                insertURLParam('didReload', '1');
              }}
            >
              {t('tryAgain', { ns: 'common' })}
            </Button>
          )}
          <Button
            onClick={() => {
              didClickReset = true;
              resetErrorBoundary();
            }}
            appearance="primary"
            hasArrow={false}
            isLoading={didClickReset}
          >
            {t('startOver', { ns: 'checkout' })}
          </Button>
        </div>
        {!isProduction && process.env.NEXT_PUBLIC_DEBUG && (
          <Accordion
            className={ErrorMessageAccordion}
            header="Fejlbesked"
            didClick={() => setErrorMessageOpen(!errorMessageOpen)}
            isOpen={errorMessageOpen}
            whiteBackground={false}
          >
            <pre>{JSON.stringify(error, null, 4)}</pre>
          </Accordion>
        )}
      </Section>
    </Container>
  );
};

export default ErrorFallback;
